<template>
  <div class="mv-carousel">
    <cq-header headertext="WHAT PEOPLE ARE SAYING ABOUT THE GAIN GURU"></cq-header>

    <b-carousel
      id="carousel-1"
      :interval="4000"
      controls
      indicators
      
    >

      <!-- Slides with custom text -->
      <b-carousel-slide class="carousel-bg">
        <h1>Hello world!</h1>
        <cq-paratext> In 15 years of my professional career I would have attended approx 50 trainings &amp; I would like to mention Manan,my current trainer as the finest I have met. No doubt all the trainers I got trained under were good but Manan is an exceptional trainer. I will explain what I mean. </cq-paratext>
        <cq-paratext> Manan is the only trainer who is interested / committed that every participant benefits out of his training. Not only does he brings the best from his participants during training but he also follows up post training, which no other trainer does. All other trainers would leave their contact number/ email address &amp; say please call if needed. Manan chases his participants till they achieve what they were committed to achieve. Another differentiating factor about Manan is he takes his participants feedback very seriously, he is ready to learn & I must confidently say he is improving every session, again most trainers take feedback but it only goes back in their files for record, no one seriously takes action.  </cq-paratext>
        <cq-paratext> I would also like to acknowledge Manan's hardwork &amp; preparation before training, it's exemplary. To sum it up I am glad to have got trained under the most passionate trainer I have met in my life. i.e. Manan Vasa. </cq-paratext>
        <div class="name">
          <cq-paratext> <b> Nimesh Mehta </b> <br>
          Director &amp; Head - Sales &amp; Products <br>
          ASK Investment Managers Limited</cq-paratext>
        </div>
      </b-carousel-slide>
      
    </b-carousel>
  </div>
</template>


<script>
import CQHeader from '../../components/ui/CQHeader.vue'
import CQPara from '../../components/ui/CQPara.vue'

export default {
    components: {
        'cq-header' : CQHeader,
        'cq-paratext' : CQPara
    }
}
</script>

<style scoped>
  .mv-carousel >>> .carousel-indicators{
      display: none;
  }

  .mv-carousel >>> .carousel-bg{
    background-image: linear-gradient(var(--secondary-color)45%, #C7C8CA); 
    height: 1100px;
  }

  .mv-carousel >>> .carousel-control-prev-icon{
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='grey' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e") !important;
  }

  .mv-carousel >>> .carousel-control-next-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='grey' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e") !important;
  }

  .mv-carousel >>> .carousel-caption {
    text-align: left;
  }

  .mv-carousel >>> .name{
    border-left: 7px solid var(--primary-color);
    padding-left: 7%;
  }

@media only screen and (min-width: 992px){
  .mv-carousel >>> .carousel-bg{
    height: 490px;
  }

  .mv-carousel >>> .name{
    padding-left: 2%;
  }
}

</style>